export const AI_GUIDE_NAME = 'SAT® Practice Partner'

export const SESSION_SIMULATION_SCENARIOS = [
  {
    slug: 'get-them-talking',
    title: 'Get Them Talking',
    description:
      'Practice breaking silence and guiding every learner to talk in the first five minutes.',
  },
  {
    slug: 'explain-it-clearly',
    title: 'Explain it Clearly',
    description: 'Practice teaching any problem clearly and guiding learners who seem confused.',
  },
  {
    slug: 'facilitate-we-do',
    title: "Facilitate a 'We Do'",
    description: "Guide learners through a problem using the 'We Do' collaborative method.",
  },
  {
    slug: 'support-stuck-learners',
    title: 'Support Stuck Learners',
    description: 'Helping one learner without losing the group takes skill.',
  },
  {
    slug: 'break-the-awkward-silence',
    title: 'Break the Awkward Silence',
    description: 'Practice turning awkward silence into real thinking time.',
  },
  {
    slug: 'all-skills-one-room',
    title: 'All Skills, One Room',
    description: 'Practice all your tutoring skills (at once) with diverse learners [20 min]',
  },
] as const satisfies { slug: string; title: string; description: string }[]

export type SessionSimulationScenarioSlug = (typeof SESSION_SIMULATION_SCENARIOS)[number]['slug']

export const SESSION_SIMULATION_SP = 5
export const SESSION_SIMULATION_SP_ATTEMPTS_PER_DAY = 3
